<div class="container">
  <h1 class="main-title">Trusted by Developers, Played by Millions</h1>
  <p class="sub-title">Real-time stats compiled from a handful of games using RoRender generated maps.</p>
  <div class="subcontainer">
    <div class="box left">
      <h2>Current Active Players</h2>
      <p class="sub-title">Real Time Impact: Players exploring RoRender powered games now.</p>
      <p class="counter" id="active-players" [pTooltip]="stats ? (stats.totalActivePlayers | number) || '' : ''" tooltipPosition="bottom"></p>
      <p class="marketing-msg">See how many players are actively in a RoRender powered game right now. A great map keeps them immersed, RoRender makes sure they never feel lost.</p>
    </div>
    <div class="box middle">
      <h2>Total Sessions</h2>
      <p class="sub-title">Clear Maps, More Playtime, More Retention</p>
      <p class="counter" id="visits" [pTooltip]="stats ? (stats.totalVisits | number) || '' : ''" tooltipPosition="bottom"></p>
      <p class="marketing-msg">Confusing games lose players: RoRender’s maps make navigation effortless, keeping players coming back for more.</p>
    </div>
    <div class="box right">
      <h2>Total Favorites</h2>
      <p class="sub-title">Loved & Remembered: Games Players Keep Coming Back To</p>
      <p class="counter" id="favorites" [pTooltip]="stats ? (stats.totalFavorites | number) || '' : ''" tooltipPosition="bottom"></p>
      <p class="marketing-msg">A well-designed minimap avoids confusion, keeps players engaged, and makes your game unforgettable. RoRender helps craft experiences that players love!</p>
    </div>
  </div>
  <p class="updated">* updated {{lastUpdatedMinutes}} minutes ago...</p>
</div>
